module.exports = __webpack_public_path__ + "media/success_sweepstakes/sun-f8c298ab.png";